


























import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'

@Component
export default class extends Vue {
    mail = ''
    password = ''
    valid = true;

    async onLogin() {
        this.valid = true;
        try {
            await api.login(this.mail, this.password)
        } catch(e) {
            if (e.message === 'Invalid login') {
                this.valid = false;
            } else {
                throw e;
            }
        }

        // this.$router.push({
        //     path: '/rate',
        // })
    }
    created() {
        let autoFillCheckCounter = 0;
        const autoFillCheck = setInterval(() => {
            autoFillCheckCounter++;
            const mailField = document.querySelector('#mail-field input') as HTMLInputElement;
            const passwordField = document.querySelector('#password-field input') as HTMLInputElement;
            if (!mailField || !passwordField) {
                clearInterval(autoFillCheck);
                return;
            }
            const mailAutofilled = mailField.matches(`:-webkit-autofill`);
            const passwordAutofilled = passwordField.matches(`:-webkit-autofill`);
            if (mailAutofilled || passwordAutofilled) {
                mailField.parentElement?.classList.add('md-has-value');
                passwordField.parentElement?.classList.add('md-has-value');
            }
            if (autoFillCheckCounter > 8 || mailAutofilled || passwordAutofilled) {
                clearInterval(autoFillCheck);
            }
        }, 200);
    }
}
